import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Hr from 'components/shared/Hr/Hr';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';

import BillingAddressInformation from './BillingAddressInformation';
import { findSelectedUsers, selectUsers } from './helpers';

const BillingProviderForm = ({
  formik,
  tax_id_types,
  selectedState,
  handleSelectState,
  states,
  customSelectStyle,
  loadedMembers
}) => {
  const handleDigitsOnlyChange = (key) => (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, '');
    formik.setFieldValue(key, onlyDigits);
  };

  return (
    <form>
      <div className="flex flex-col gap-2">
        <div className="mb-4">
          <div className="mb-1 text-base font-500 text-neutral-900">Billing Information</div>
          <p className="text-sm text-neutral-700">
            Enter billing provider details, including identifiers and contact information.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-x-3 gap-y-4">
          <Input
            id="name"
            type="text"
            label="Name"
            name="bill_name"
            placeholder="Name"
            required
            onChange={formik.handleChange}
            value={formik.values.bill_name}
            error={formik.touched.bill_name && formik.errors.bill_name}
          />
          <Input
            id="npi"
            type="text"
            name="bill_npi"
            label="Billing NPI"
            placeholder="Billing NPI"
            required
            value={formik.values.bill_npi}
            onChange={handleDigitsOnlyChange('bill_npi')}
            error={formik.touched.bill_npi && formik.errors.bill_npi}
          />
          <Input
            id="taxid"
            type="text"
            name="bill_taxid"
            label="Billing Tax ID"
            placeholder="Billing Tax ID"
            required
            onChange={handleDigitsOnlyChange('bill_taxid')}
            value={formik.values.bill_taxid}
            error={formik.touched.bill_taxid && formik.errors.bill_taxid}
          />
          <Select
            inputId="taxidType"
            options={tax_id_types}
            styles={customSelectStyle}
            label="Billing Tax ID Type"
            required
            placeholder="Billing Tax ID Type"
            value={formik.values.bill_taxid_type}
            onChange={(value) => formik.setFieldValue('bill_taxid_type', value)}
            error={formik.touched.bill_taxid_type && formik.errors.bill_taxid_type}
          />
          <Input
            label="Billing Taxonomy"
            type="text"
            id="taxonomy"
            name="bill_taxonomy"
            placeholder="Billing Taxonomy"
            onChange={formik.handleChange}
            value={formik?.values?.bill_taxonomy}
            error={formik?.touched?.bill_taxonomy && formik?.errors?.bill_taxonomy}
          />
          <Input
            label=" Billing Atypical ID"
            type="text"
            placeholder="Billing Atypical ID"
            name="bill_id"
            value={formik?.values?.bill_id}
            onChange={formik.handleChange}
            id="id"
            error={formik?.touched?.bill_id && formik?.errors?.bill_id}
          />

          <Input
            label="Phone number"
            type="text"
            placeholder="+1(123)4567890"
            name="bill_phone"
            value={formik.values.bill_phone}
            onChange={formik.handleChange}
            id="phoneNumber"
            error={formik?.touched?.bill_phone && formik?.errors?.bill_phone}
          />
        </div>
      </div>
      <Hr />
      <BillingAddressInformation
        formik={formik}
        selectedState={selectedState}
        handleSelectState={handleSelectState}
        states={states}
        customSelectStyle={customSelectStyle}
      />
      <Hr />
      <div>
        <div className="flex flex-col">
          <div className="mb-4">
            <div className="mb-1 text-base font-500 text-neutral-900">Providers</div>
            <p className="text-sm text-neutral-700">
              Please select the providers associated with this billing provider.
            </p>
          </div>
          <Select
            label="Providers"
            menuPortalTarget={document.body}
            placeholder="Type and select providers"
            value={findSelectedUsers(formik?.values?.practitioner_ids, loadedMembers) || []}
            onChange={(value) => selectUsers(value, formik)}
            options={loadedMembers}
            styles={customSelectStyle}
            inputId="practitioner"
            menuPlacement="top"
            isMulti={true}
            error={formik?.touched?.practitioner_ids && formik?.errors?.practitioner_ids}
          />
        </div>
      </div>
    </form>
  );
};

export default withErrorBoundary(BillingProviderForm);
